// extracted by mini-css-extract-plugin
module.exports = {"Component":"DataTableTcxhFeedbackList_Component__1536z"};